module.exports = __webpack_public_path__ + "img/burn-apple.efea9f5d.png";